const getActivePageId = (state) => state.ws.site.meta.activePage;

export default getActivePageId;
